import React from 'react';
import { Outlet } from 'react-router-dom';

const SchoolGroupMembersRouter: React.FC = () => {
  return <Outlet />;
};

export default SchoolGroupMembersRouter;
